export default __webpack_public_path__ + "static/media/open-graph.5f8cee32.svg";